export const DealerOnlineWebsiteName = 'DealerOnline'